import { PaymentStatus } from '../../../hooks/queries/usePaymentList';
import theme from '../../../theme';

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'paid':
    case 'succeeded':
      return theme.palette.success.main;
    case 'refunded':
    case 'refund_requested':
      return '#6366F1';
    case 'pending':
      return '#F59E0B';
    case 'failed':
    case 'canceled':
    case 'unpaid':
      return theme.palette.error.main;
    default:
      return theme.palette.error.main;
  }
};

export const getStatusHoverColor = (status: string) => {
  switch (status) {
    case 'paid':
    case 'succeeded':
      return theme.palette.success.dark;
    case 'refunded':
    case 'refund_requested':
      return '#4F46E5';
    case 'pending':
      return '#B45309';
    case 'failed':
    case 'canceled':
    case 'unpaid':
      return theme.palette.error.dark;
    default:
      return theme.palette.error.dark;
  }
};

export const formatStatus = (status: string) => {
  return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
};

export function getPaymentSummaryHeader(status: string) {
  return status === PaymentStatus.Paid ||
    status === PaymentStatus.Refunded ||
    status === 'refund_requested'
    ? 'Total paid:'
    : 'Total to pay:';
}
